import { gql } from '@apollo/client'

export const GET_ORDERS_BY_EVENT_ID = gql`
  query getOrdersByEventId($eventId: String!, $userIds: [String!]!) {
    getOrdersByEventId(eventId: $eventId, userIds: $userIds) {
      orderId
      userId
      paid
      eventId
      quantity
      tickets {
        title
        email
        fullName
        discountCode
      }
    }
  }
`
